import { CODE_TYPES, CodeType } from './constants';

/**
 * Resolves the code type based on the `allowAlphanumeric` configuration flag.
 *
 * This function maps a boolean value from the global configuration to a corresponding
 * `CodeType`, which can be either `'alphanumeric'` or `'numeric'`. It is primarily
 * intended for internal use, but may also serve utility needs when determining
 * code format behavior based on system settings.
 * @param {*} allowAlphanumeric
 * @returns {'alphanumeric' | 'numeric'} Returns `'alphanumeric'` if `allowAlphanumeric` is true; otherwise, returns `'numeric'`.
 *
 * @example
 * // With allowAlphanumeric === true:
 * resolveCodeTypeFromConfig(); // => 'alphanumeric'
 *
 * // With allowAlphanumeric === false:
 * resolveCodeTypeFromConfig(); // => 'numeric'
 */
export function getCodeType(allowAlphanumeric: boolean): CodeType {
  return allowAlphanumeric ? CODE_TYPES.ALPHANUMERIC : CODE_TYPES.NUMERIC;
}
